import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Card from '../common/Card';
import Button from '../common/Button';
import Loading from '../common/Loading';
import AssociationCard from './AssociationCard';
import AssociationDetails from './AssociationDetails';
import CreateAssociationModal from './CreateAssociationModal';
import AssignOwnerModal from './AssignOwnerModal'; // ← NOUVEAU

const AssociationList = () => {
  const [associations, setAssociations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedAssociation, setSelectedAssociation] = useState(null);
  const [showAssignOwnerModal, setShowAssignOwnerModal] = useState(false); // ← NOUVEAU
  const [associationToAssign, setAssociationToAssign] = useState(null); // ← NOUVEAU
  const [filters, setFilters] = useState({
    active: 'all',
    autoMode: 'all',
    search: '',
  });

  useEffect(() => {
    fetchAssociations();
  }, []);

  const fetchAssociations = async () => {
    try {
      const response = await api.get('/associations');
      setAssociations(response.data.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  // ← NOUVELLE FONCTION
  const handleAssignOwner = (association) => {
    setAssociationToAssign(association);
    setShowAssignOwnerModal(true);
  };

  const filteredAssociations = associations.filter((assoc) => {
    if (filters.active !== 'all' && assoc.active !== (filters.active === 'true')) {
      return false;
    }
    if (filters.autoMode !== 'all' && assoc.autoMode !== (filters.autoMode === 'true')) {
      return false;
    }
    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      return (
        assoc.name.toLowerCase().includes(searchLower) ||
        assoc.sensorId?.name.toLowerCase().includes(searchLower) ||
        assoc.switchId?.name.toLowerCase().includes(searchLower)
      );
    }
    return true;
  });

  if (loading) return <Loading />;

  if (selectedAssociation) {
    return (
      <AssociationDetails
        association={selectedAssociation}
        onClose={() => setSelectedAssociation(null)}
        onUpdate={fetchAssociations}
      />
    );
  }

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-800">Associations Sensor ↔ Switch</h1>
          <p className="text-gray-600 mt-1">
            Gérez les associations entre capteurs et interrupteurs
          </p>
        </div>
        <Button onClick={() => setShowCreateModal(true)}>
          + Nouvelle Association
        </Button>
      </div>

      {/* Filtres */}
      <Card className="mb-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Rechercher
            </label>
            <input
              type="text"
              value={filters.search}
              onChange={(e) => setFilters({ ...filters, search: e.target.value })}
              placeholder="Nom, sensor, switch..."
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-primary"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Statut
            </label>
            <select
              value={filters.active}
              onChange={(e) => setFilters({ ...filters, active: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-primary"
            >
              <option value="all">Tous</option>
              <option value="true">Actif</option>
              <option value="false">Inactif</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Mode Auto
            </label>
            <select
              value={filters.autoMode}
              onChange={(e) => setFilters({ ...filters, autoMode: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-primary"
            >
              <option value="all">Tous</option>
              <option value="true">Activé</option>
              <option value="false">Désactivé</option>
            </select>
          </div>
        </div>
      </Card>

      {/* Liste */}
      {filteredAssociations.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredAssociations.map((association) => (
            <AssociationCard
              key={association._id}
              association={association}
              onClick={setSelectedAssociation}
              onUpdate={fetchAssociations}
              onAssignOwner={handleAssignOwner} // ← PASSER LA FONCTION
            />
          ))}
        </div>
      ) : (
        <Card>
          <p className="text-center text-gray-500 py-8">
            Aucune association trouvée
          </p>
        </Card>
      )}

      {/* Modal Création */}
      {showCreateModal && (
        <CreateAssociationModal
          onClose={() => setShowCreateModal(false)}
          onSuccess={() => {
            setShowCreateModal(false);
            fetchAssociations();
          }}
        />
      )}

      {/* ← NOUVEAU MODAL */}
      {showAssignOwnerModal && associationToAssign && (
        <AssignOwnerModal
          association={associationToAssign}
          onClose={() => {
            setShowAssignOwnerModal(false);
            setAssociationToAssign(null);
          }}
          onSuccess={() => {
            setShowAssignOwnerModal(false);
            setAssociationToAssign(null);
            fetchAssociations();
          }}
        />
      )}
    </div>
  );
};

export default AssociationList;